<template>
    <div>
        <div class="badge" :class="styleClass" v-on:click="openModal()">
            {{currentState.status}}
        </div>
        <b-modal ref="editModal" :title="t('Change state')" :hide-footer="loading === true">
            <div class="p-4 text-center" v-if="loading === true">
                <font-awesome-icon icon="spinner" size="2x" :spin="true"/>
                <div class="mt-2">{{t('Saving')}}</div>
            </div>
            <titan-form ref="schema"
                        v-if="loadedForm === true && loading === false"
                        :renderInCard="false"
                        :schema="schema"
                        :model="formData"
            />
            <template slot="modal-footer" v-if="loading === false">
                <button type="button" class="btn btn-success mr-auto" v-on:click="changeState()">
                    {{t('Save')}}
                </button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            TitanForm
        },
        props: {
            currentState: {
                type: Object | null,
                required: true,
            },
            id: {
                type: Number,
                required: true
            },
            item: {
                type: Object,
                default: () => {return {}}
            }
        },
        watch: {
            currentState(newState, oldState) {
                if (newState === null || oldState === null || newState.id !== oldState.id) {
                    this.formData.state = this.currentState;
                }
            }
        },
        computed: {
            styleClass() {
                let styles = 'badge-' + this.currentState.color;
                if (this.currentState.slug !== 'concept') {
                    styles += ' c-pointer';
                }
                return styles;
            }
        },
        mounted() {
            this.formData.state = this.currentState;
            Object.keys(this.formData).forEach(key => {
                if (this.item[key] !== undefined) {
                    this.formData[key] = this.item[key];
                }
            });
        },
        methods: {
            openModal() {
                if (this.currentState.slug !== 'concept') {
                    this.$refs.editModal.show();
                    this.loadedForm = true
                }
            },
            changeState() {
                if (this.$refs.schema.isValid()) {
                    this.loading = true;

                    const data = {...this.formData};
                    data.id = this.id;
                    data.stateId = this.formData.state.id;

                    this.$store.dispatch('applications/setState', data).then(res => {
                        this.$refs.editModal.hide();
                        this.loading = false;
                        setTimeout(() => {
                            this.$emit('changeState', res);
                        }, 50);
                    }).catch(reason => {
                        this.loading = false;
                    });

                }
            }
        },
        data() {
            return {
                loading: false,
                loadedForm: false,
                formData: {
                    state: null,
                    approvalDate: new Date(),
                    expiryDate: null,
                    approvedPackages: null,
                    approvalEvidenceNo: null,
                    approvalComments: null,
                    repeat: null,
                    dateStartRepeat: null,
                },
                schema: [
                    {
                        name: this.t('State'),
                        type: 'main',
                        showHeading: false,
                        fields: [
                            {
                                type: "titanSelect",
                                codeBook: 'applicationsStatuses',
                                label: this.t('New state'),
                                model: "state",
                                valueLabel: 'status',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: "titanDatePicker",
                                label: this.t('Valid from'),
                                model: 'approvalDate',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                language: this.$i18n.locale,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: "titanDatePicker",
                                label: this.t('Valid till'),
                                model: 'expiryDate',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                language: this.$i18n.locale,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: 'titanDatePicker',
                                label: this.t('Repetition from'),
                                model: 'dateStartRepeat',
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                language: this.$i18n.locale,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Number repeat'),
                                model: 'repeat',
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                language: this.$i18n.locale,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Approved packages'),
                                model: 'approvedPackages',
                                max: 999,
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Approval evidence'),
                                model: 'approvalEvidenceNo',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }, {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Approval comments'),
                                model: 'approvalComments',
                                required: false,
                                validator: VueFormGenerator.validators.string,
                                visible: () => {
                                    return this.formData.state !== null && this.formData.state.slug === 'accepted'
                                }
                            }
                        ]
                    }
                ],
            };
        }

    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/change-state.vue